import React from 'react'

const SocialMedias = () => {
  return (
    <div className="text-center" style={{ margin: '30px 0' }}>
      <a
        href="https://www.youtube.com/@revesdebarousse"
        style={{ marginRight: '20px' }}
      >
        <img
          src="/images/social-medias/youtube_icon_128.png"
          alt="YouTube"
          height="48"
          className="social-icon"
        />
      </a>
      <a
        href="https://www.instagram.com/revesdebarousse"
        style={{ marginRight: '20px' }}
      >
        <img
          src="/images/social-medias/instagram_icon_128.png"
          alt="Instagram"
          height="48"
          className="social-icon"
        />
      </a>
      <a href="https://x.com/revesdebarousse" style={{ marginRight: '20px' }}>
        <img
          src="/images/social-medias/x_icon_128.png"
          alt="Twitter"
          height="48"
          className="social-icon"
        />
      </a>
      <a href="https://www.facebook.com/profile.php?id=61556998888244">
        <img
          src="/images/social-medias/facebook_icon_128.png"
          alt="Facebook"
          height="48"
          className="social-icon"
        />
      </a>
    </div>
  )
}

export default SocialMedias
